<template>
  <!-- 禅友文讯 -->
  <div class="plowCloudBrief">
    <topBack>{{ $t("navName")[3] }}</topBack>
    <!-- 导航 -->
    <barF5></barF5>
    <header class="plowCloudNav flex-between-wrap">
      <div
        v-for="(item, index) in childNav"
        :key="index"
        class="navItem"
        :class="{ activeNav: index == nowIndex }"
        @click="changeNav($event, index, item)"
      >
        {{ item.cate_name }}
      </div>
    </header>
    <barF5></barF5>

    <!-- 内容 -->
    <div class="container">
      <experience
        v-if="nowIndex == 0 && childNav[0].cate_name"
        :cateList="experienceList"
        :title="childNav[0].cate_name"
      ></experience>
      <letter
        v-if="nowIndex == 1 && childNav[1].cate_name"
        :cateId="childNav[1].id"
        :title="childNav[1].cate_name"
      ></letter>
    </div>
    <!-- 去除底部button所占的位置 -->
    <!-- <empty></empty> -->
    <!-- 底部button -->
    <!-- <footer>
        <Button>{{$t('firstHome')}}</Button>
    </footer> -->
  </div>
</template>

<script>
import {
  getCateList,
  StudyExperienceCate,
  // StudyExperienceList
} from "../../api/apis";
import { getNavName } from "../../common/js/common.js";

import topBack from "../../components/topBack.vue";
import barF5 from "../../components/barF5"; //空隙bar
import experience from "./experience"; //耕雲導師簡歷
import letter from "./letter"; //耕雲導師法相

import empty from "../../components/empty";
import Button from "../../components/button"; //返回首頁
export default {
  name: "plowCloud",
  components: {
    topBack,
    barF5,
    experience,
    letter,
    empty,
    Button,
  },
  props: {
    // childNav: {
    //   type: Array,
    //   default: () => [{
    //       name: "修學心得"
    //     },
    //     {
    //       name: "書信往來"
    //     }
    //   ]
    // }
  },
  data() {
    return {
      nowIndex: 0,
      experienceList: [], //三级菜单
      childNav: [
        // {
        //     name: "修學心得"
        // },
        // {
        //     name: "書信往來"
        // }
      ],
    };
  },
  methods: {
    changeNav(e, index, item) {
      // this.nowIndex = index;
      // localStorage.setItem('nowIndex', index);
      // if (this.$route.query.id) {
      //   this.nowIndex = this.$route.query.id;
      // } else if (localStorage.getItem('nowIndex')) {
      //   this.nowIndex = localStorage.getItem('nowIndex')
      // }
      // getCateList().then(res => {
      //   this.childNav = getNavName(res[2]);
      //   if (this.nowIndex == 0) {
      //     this.getExperienceCate(res[2][this.nowIndex].id);
      //   }
      // });
      localStorage.setItem("nowNav_type", index);
      this.$router.push({
        path: "/friendWen",
        query: {
          id: item.id,
        },
      });
      if (this.$route.query.id == 15) {
        this.nowIndex = 0;
      } else {
        this.nowIndex = 1;
      }
      getCateList().then((res) => {
        this.childNav = getNavName(res[2]);
        console.log(this.childNav);
        if (this.nowIndex == 0) {
          this.getExperienceCate(res[2][this.nowIndex].id);
        }
      });
    },
    getExperienceCate(id) {
      StudyExperienceCate(id).then((res) => {
        this.experienceList = res;
      });
    },
  },
  mounted() {
    if (this.$route.query.id == 15) {
      this.nowIndex = 0;
    } else {
      this.nowIndex = 1;
    }
    getCateList().then((res) => {
      this.childNav = getNavName(res[2]);
      console.log(this.childNav);
      if (this.nowIndex == 0) {
        this.getExperienceCate(res[2][this.nowIndex].id);
      }
    });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.plowCloudNav {
  /* display: grid;
  grid-template-columns: repeat(2, 49.5%);
  grid-column-gap: 0.15rem;
  grid-row-gap: 0.15rem; */
  padding: 0.64rem;
  text-align: left;
}

.navItem {
  width: 9.23rem;

  height: 1.71rem;
  /* margin: 0.15rem; */
  box-sizing: border-box;
  line-height: 1.71rem;
  background-color: #f4f3ee;
  color: #666666;
  padding-left: 1.07rem;
  font-size: 0.85rem;
  font-weight: 600;
}

.activeNav {
  background-color: #047bcd;
  color: #fff;
}

.container {
  /* padding: 0.64rem; */
  color: #333333;
  text-align: left;
}
</style>